import React from 'react'
import SbEditable from 'storyblok-react'
import Form from './Components/Form'
import FormField from './Components/FormField'

const ContactForm = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <Form
                name="contact"
                action="/thank-you/"
            >
                <FormField
                    containerClass="sm:col-span-2"
                    id="first-name"
                    label="First name"
                    required
                    type="text"
                    autoComplete="given-name"
                    placeholder="First name*"
                />
                <FormField
                    containerClass="sm:col-span-2"
                    id="last-name"
                    label="Last name"
                    required
                    type="text"
                    autoComplete="family-name"
                    placeholder="Last name*"
                />
                <FormField
                    containerClass="sm:col-span-2"
                    id="company-name"
                    label="Company name"
                    type="text"
                    autoComplete="organization"
                    placeholder="Company name*"
                />
                <FormField
                    containerClass="sm:col-span-2"
                    id="position"
                    label="Position"
                    type="text"
                    placeholder="Position"
                />
                <FormField
                    containerClass="sm:col-span-2"
                    id="email"
                    label="Email address"
                    required
                    type="email"
                    autoComplete="email"
                    placeholder="Email address*"
                />
                <FormField
                    containerClass="sm:col-span-2"
                    id="file-upload-test"
                    label="File upload"
                    type="file"
                />
                <FormField
                    containerClass="sm:col-span-2"
                    id="phone-number"
                    label="Phone Number"
                    required
                    type="text"
                    autoComplete="tel"
                    placeholder="Phone Number*"
                />
                <FormField
                    containerClass="sm:col-span-2"
                    id="message"
                    label="Your Enquiry"
                    required
                    type="textarea"
                    placeholder="Please type your message here...*"
                />
                <FormField
                    containerClass="sm:col-span-2"
                    id="privacy_policy"
                    label="I can confirm I have read and agree to the TLF Research Ltd <a href='#' className='text-red'>Privacy Policy.</a>"
                    required
                    type="checkbox"
                    placeholder="Please type your message here...*"
                />
            </Form>
        </SbEditable>
    )
}

export default ContactForm